export default __webpack_public_path__ + "static/media/Health Potion.11720632.jpg";